import axios2 from '../api/axios';
export const currencyServices = {
    getcurrency   
}

function getcurrency(){
   return axios2.get('getcurrency',(response)=>{
        return response;    
    }).catch((error)=>{
        console.log(error);  
    })
}
